"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GameConstants_1 = require("./GameConstants");
var GameVars_1 = require("./GameVars");
var GameManager = /** @class */ (function () {
    function GameManager() {
    }
    GameManager.init = function (game) {
        GameManager.game = game;
    };
    GameManager.consoleLog = function (text) {
        if (GameConstants_1.GameConstants.VERBOSE) {
            console.log(text);
        }
    };
    GameManager.resetValues = function () {
        GameVars_1.GameVars.moves = 0;
        GameVars_1.GameVars.points = 0;
    };
    GameManager.startSoloGame = function () {
        // 
    };
    GameManager.loadLocalStorage = function () {
        var audio = oMetaManager.localGetItem(GameConstants_1.GameConstants.AUDIO_STATE_KEY);
        if (audio) {
            GameVars_1.GameVars.sound = JSON.parse(audio);
        }
        else {
            GameVars_1.GameVars.sound = true;
            oMetaManager.localSetItem(GameConstants_1.GameConstants.AUDIO_STATE_KEY, JSON.stringify(GameVars_1.GameVars.sound));
        }
        var points = oMetaManager.localGetItem(GameConstants_1.GameConstants.SCORE_STATE_KEY);
        if (points) {
            GameVars_1.GameVars.maxPoints = JSON.parse(points);
        }
        else {
            GameVars_1.GameVars.points = 0;
            oMetaManager.localSetItem(GameConstants_1.GameConstants.SCORE_STATE_KEY, JSON.stringify(GameVars_1.GameVars.points));
        }
    };
    return GameManager;
}());
exports.GameManager = GameManager;
